import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import apiClient from '../../shared/services/apiClient';
import useAuthStore from '../../shared/stores/authStore';
import useAppStore from '../../shared/stores/appStore';
import { hasYearRecords, historyText } from '../../shared/utils/participantHistoryText';
import '../../pages/ParticipantHistoryPage.css';

export default function ParticipantHistoryEntry() {
  const user = useAuthStore((s) => s.user);
  const language = useAppStore((s) => s.language);
  const location = useLocation();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [failed, setFailed] = useState(false);
  const [reload, setReload] = useState(0);
  const enabled = hasYearRecords(user);
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    apiClient.get('/auth/record-years').then((data) => { if (active) { setInfo(data); setFailed(false); } })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [user?.id, enabled, reload]);
  if (!enabled) return null;
  const text = historyText(language);
  const params = new URLSearchParams(location.search);
  const isMap = location.pathname === '/map';
  const isRecords = location.pathname === '/records';
  const year = (isMap || isRecords) ? Number(params.get('year')) || info?.current_year : info?.current_year;
  const tab = isRecords ? params.get('tab') || 'chats'
    : location.pathname.startsWith('/meeting') ? 'meetings' : location.pathname === '/matching' ? 'matches' : 'chats';
  const changeYear = (event) => {
    const next = Number(event.target.value);
    if (isMap) return navigate(`/map?year=${next}`);
    const live = { chats: '/chats', meetings: '/meetings', matches: '/matching' };
    navigate(next === info.current_year ? live[tab] : `/records?year=${next}&tab=${tab}`);
  };
  return <nav className="participant-history-entry" aria-label={text.title}>
    <label className="participant-year-select">{isMap ? (language === 'ko' ? '지도 연도' : 'Map year') : text.year}
      <select aria-label={isMap ? (language === 'ko' ? '지도 연도' : 'Map year') : text.year}
        value={year || ''} disabled={!info} onChange={changeYear}>
        {!info && <option value="">{text.loading}</option>}
        {info?.years.map((item) => <option key={item.year} value={item.year}>{item.name}{item.is_current ? ` · ${text.current}` : ''}</option>)}
      </select>
    </label>
    <Link to="/records">{text.title} →</Link>
    {String(user?.user_type).toUpperCase() === 'ADMIN' && <a href="/admin/chats" onClick={() => {
      try { localStorage.setItem('dsk_admin_event_year', String(year || info?.current_year)); } catch { /* optional persisted filter */ }
    }}>{language === 'ko' ? '전체 참가자 채팅 보기' : 'View all participant chats'}</a>}
    {String(user?.user_type).toUpperCase() !== 'ADMIN' && <span>{info?.current_year} · {user.registered_for_current_year ? text.registered : text.notRegistered}</span>}
    {failed && <button onClick={() => setReload((n) => n + 1)}>{text.retry}</button>}
  </nav>;
}
